var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_3992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8287 5.6302L12.8444 1.64593C12.7514 1.55289 12.6245 1.5 12.4922 1.5H5.51953C4.69566 1.5 4.02539 2.17027 4.02539 2.99414V17.0059C4.02539 17.8297 4.69566 18.5 5.51953 18.5H15.4805C16.3043 18.5 16.9746 17.8297 16.9746 17.0059V5.98242C16.9746 5.84662 16.9176 5.71909 16.8287 5.6302ZM12.9902 3.20043L15.2742 5.48438H13.4883C13.2137 5.48438 12.9902 5.26095 12.9902 4.98633V3.20043ZM15.4805 17.5039H5.51953C5.24491 17.5039 5.02148 17.2805 5.02148 17.0059V2.99414C5.02148 2.71952 5.24491 2.49609 5.51953 2.49609H11.9941V4.98633C11.9941 5.8102 12.6644 6.48047 13.4883 6.48047H15.9785V17.0059C15.9785 17.2805 15.7551 17.5039 15.4805 17.5039Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 8.53906H7.51172C7.23666 8.53906 7.01367 8.76205 7.01367 9.03711C7.01367 9.31216 7.23666 9.53516 7.51172 9.53516H13.4883C13.7633 9.53516 13.9863 9.31216 13.9863 9.03711C13.9863 8.76205 13.7633 8.53906 13.4883 8.53906Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 10.5312H7.51172C7.23666 10.5312 7.01367 10.7542 7.01367 11.0293C7.01367 11.3044 7.23666 11.5273 7.51172 11.5273H13.4883C13.7633 11.5273 13.9863 11.3044 13.9863 11.0293C13.9863 10.7542 13.7633 10.5312 13.4883 10.5312Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 12.5234H7.51172C7.23666 12.5234 7.01367 12.7464 7.01367 13.0215C7.01367 13.2965 7.23666 13.5195 7.51172 13.5195H13.4883C13.7633 13.5195 13.9863 13.2965 13.9863 13.0215C13.9863 12.7464 13.7633 12.5234 13.4883 12.5234Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4961 14.5156H7.51172C7.23666 14.5156 7.01367 14.7386 7.01367 15.0137C7.01367 15.2887 7.23666 15.5117 7.51172 15.5117H11.4961C11.7711 15.5117 11.9941 15.2887 11.9941 15.0137C11.9941 14.7386 11.7711 14.5156 11.4961 14.5156Z",
    fill: "#494949",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_3992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(2 1.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIconGrey);
export default __webpack_public_path__ + "static/media/application_icon_grey.9e0a14fe872042b38770c0cadd5ab767.svg";
export { ForwardRef as ReactComponent };